import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import type { ThanksMenu } from "../../shared/thanks";
import { api } from "../api";
import { Banner, messageOf } from "./ui";

type MenuOffer = { value: ThanksMenu; label: string };

type MenuPage = {
  brand: string | null;
  menus: MenuOffer[];
  choice: ThanksMenu | null;
  menu_label: string | null;
};

export function MenuChoicePage() {
  const { token } = useParams();
  const [page, setPage] = useState<MenuPage | null>(null);
  const [error, setError] = useState<string | null>(null);
  const [note, setNote] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    if (!token) return;
    api<MenuPage>(`/public/menu-choice/${encodeURIComponent(token)}`)
      .then((result) => {
        setPage(result);
        if (result.menu_label) setNote(`Έχετε διαλέξει το μενού ${result.menu_label}. Μπορείτε να το αλλάξετε.`);
      })
      .catch((reason: unknown) => setError(messageOf(reason)));
  }, [token]);

  async function choose(choice: ThanksMenu) {
    if (!token || busy) return;
    setBusy(true);
    setError(null);
    try {
      const result = await api<{ menu_label: string; message: string }>(`/public/menu-choice/${encodeURIComponent(token)}`, {
        method: "POST",
        body: JSON.stringify({ choice }),
      });
      setPage((current) => current ? { ...current, choice, menu_label: result.menu_label } : current);
      setNote(result.message);
    } catch (reason: unknown) {
      setError(messageOf(reason));
    } finally {
      setBusy(false);
    }
  }

  const house = page?.brand ?? "μας";
  return (
    <div className="public menu-choice">
      <p className="meta">Μενού γευσιγνωσίας</p>
      <h1>{page?.brand ?? "Διαλέξτε μενού"}</h1>
      <p className="lede">Σας ευχαριστούμε που ήρθατε στη γευσιγνωσία {page?.brand ? `στο ${house}` : "μαζί μας"}. Επιλέξτε ένα από τα 3 διαθέσιμα μενού: το Α, το Β ή το Γ.</p>
      <Banner error={error} note={note} />
      {page ? (
        <div className="menu-options">
          {page.menus.map((menu) => (
            <button key={menu.value} type="button" className="choice" aria-pressed={page.choice === menu.value} disabled={busy} onClick={() => void choose(menu.value)}>
              {menu.label}
            </button>
          ))}
        </div>
      ) : null}
    </div>
  );
}
